import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'

/**
 * Represents a location (a "spot") in the UI where payment advertising can render.
 */
export const PaymentAdvertisingSpot = {
  /** On the cart page */
  CART: 'cart',

  /** In 'My Orders' */
  ORDERS: 'orders',

  /** On the product page */
  PRODUCT: 'product',

  /** In a product card on a listing page */
  PRODUCT_CARD: 'product-card',
} as const

export type PaymentAdvertisingSpot = UnionOfPropertyTypes<
  typeof PaymentAdvertisingSpot
>
